module.exports = __webpack_public_path__ + "static/media/vertical-right-corner-bracket.62baf78d.svg";